var copyLink = {
    init: function() {
        var self = this;

        $( '[data-copy-link]' ).on( 'click', function() {
            var link = $( this ).attr( 'data-copy-link' );
            self.copyToClipBoard( link );
        } );
    },
    copyToClipBoard: function( str ) {
        var el = document.createElement( 'textarea' );
        el.value = str;
        document.body.appendChild( el );
        el.select();
        document.execCommand( 'copy' );
        document.body.removeChild( el );
    }
};

export {
    copyLink
};
